export default "__VITE_ASSET__IP2cJoHy__"